import {
  pdfjs,
} from 'react-pdf';

// Importing react-pdf runs its default assignment first; we override immediately after.
// Use the non-min worker: Edge fails to load pdf.worker.min.mjs in our bundle setup.
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.mjs',
  import.meta.url,
).toString();
